import { useState } from 'react';
import useFetch from '../../../hooks/useFetch';
import { buildEndpoint } from '../EndPoints';
import { ServiceEvents } from '../shared/interfaces';

export interface Country {
    id: number;
    name: string;
    code: string;
    phone_code: string;
}

export interface Region {
    id: number;
    name: string;
    code: string;
}

export interface Commune {
    id: number;
    name: string;
    region_id: number;
}

const useLocationService = () => {
    const { doGet } = useFetch();
    
    const [fetchingCountries, setFetchingCountries] = useState(false);
    const [fetchingRegions, setFetchingRegions] = useState(false);
    const [fetchingCommunes, setFetchingCommunes] = useState(false);

    /**
     * Obtiene todos los países
     */
    const getCountries = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint('communes/countries'),
            setFetching: setFetchingCountries
        });
    };

    /**
     * Obtiene todas las regiones de Chile
     */
    const getRegions = (events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint('communes/regions'),
            setFetching: setFetchingRegions
        });
    };

    /**
     * Obtiene las comunas de una región específica
     * @param regionId - ID de la región
     */
    const getCommunesByRegion = (regionId: number, events: ServiceEvents = {}) => {
        doGet({
            ...events,
            url: buildEndpoint(`communes/regions/${regionId}/communes`),
            setFetching: setFetchingCommunes
        });
    };

    return {
        getCountries,
        getRegions,
        getCommunesByRegion,
        fetchingCountries,
        fetchingRegions,
        fetchingCommunes
    };
};

export default useLocationService;

